import React from "react";
import CommonModal from "../Modals/CommonModal";
import InfiniteDotLoader from "../../utils/InfiniteDotLoader";
import { useSelector } from "react-redux";
import { useUploadModal } from "../../Logic/Uploader/useUploadModal";

const UploderClosinWarning = ({
  uploadAlert,
  setUploadAlert,
  handleQuitUploading
}) => {
  const { status } = useSelector((state) => state.gallery);
  return (
    <CommonModal
      backdrop="static"
      keyboard={false}
      showModal={uploadAlert}
      onClose={!uploadAlert}
      setShowModal={() => {
        setUploadAlert(!uploadAlert);
      }}
      centered={true}
      className={"create-project-modal"}
      title={<h4>Upload in Progress</h4>}
      content={
        <>
          <div>
            <p>
              Image uploading is still in progress. Closing this window will
              cancel the upload. Are you sure you want to proceed?
            </p>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-border-grey"
              onClick={(e) => setUploadAlert(false)}
            >
              No
            </button>
            <button
              disabled=""
              className="btn btn-primary"
              onClick={() => handleQuitUploading()}
            >
              {status === "loading" ? <InfiniteDotLoader /> : "Yes"}
            </button>
          </div>
        </>
      }
    />
  );
};

export default UploderClosinWarning;
